import { useQuery } from '@sequencehq/api'
import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'
import { TagInputSelectControlField } from '@sequencehq/core-components'
import React from 'react'

export const UsageEventTypeSelect = (
  props: Omit<
    React.ComponentProps<typeof TagInputSelectControlField>,
    'options'
  >
) => {
  const { data } = useQuery(dashboard20240730Client.getUniqueUsageEventTypes)

  const eventTypeOptions = data?.items.map(v => ({ label: v, value: v })) ?? []

  return (
    <TagInputSelectControlField
      allowCreate
      {...props}
      label="Event type"
      placeholder="Select event type"
      options={eventTypeOptions.filter(option => option.value)}
    />
  )
}
